module.exports = __webpack_public_path__ + "img/ssu.af933989.png";